import React from 'react';

const SvgMailStatistics = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M4 4a2 2 0 00-2 2v12a2 2 0 002 2h10v-2H4V9.002L12 14l8-4.998V13h2V6a2 2 0 00-2-2H4zm0 2h16v1.002L12 12 4 7.002V6zm15 9v7h-1v-4h-2v6h8v-7h-2v5h-1v-7h-2z" />
  </svg>
);

export default SvgMailStatistics;
